export enum SliceType {
  AiWorkflowBuilds = 'aiWorkflowBuilds',
  Automation = 'automation',
  Chatbot = 'chatbot',
  Dashboards = 'dashboards',
  DashboardV2 = 'dashboard_v2',
  DocumentEditors = 'documentEditors',
  DocumentsNavigation = 'documentsNavigation',
  FieldAi = 'fieldAi',
  Pages = 'pages',
  SearchV3 = 'search_v3',
  Upload = 'upload',
  Webhooks = 'webhooks',
  XRay = 'xRay',
  xRayDebug = 'xRayDebug',
  XRayLibrary = 'xRayLibrary',
}
